import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_FOOD_MOOD,
  FETCH_FOOD_MOODS,
  RENAME_FOOD_MOOD,
  RESET_FOOD_MOOD_TREE,
  SET_DATA_FOR_RENAMING_FOOD_MOOD,
} from '../action-types'

export const cleanupFetchFoodMoods = createAction(FETCH_FOOD_MOODS.CLEANUP)
export const addFoodMood = createPayloadAction(ADD_FOOD_MOOD)
export const renameFoodMood = createPayloadAction(RENAME_FOOD_MOOD)
export const resetFoodMoodTree = createAction(RESET_FOOD_MOOD_TREE)

export const setDataForRenamingFoodMood = createPayloadAction(
  SET_DATA_FOR_RENAMING_FOOD_MOOD,
)
